import { useContext, useEffect, useState } from "react";
import { SubjectContext } from "../../contexts/subjects-context";

import "bootstrap/dist/css/bootstrap.min.css";
import { useAuth } from "@clerk/clerk-react";
import createAxiosInstance from "../utility/utils";
import { Breadcrumb, Container } from "react-bootstrap";

export default function ListSubjects(props) {
  const { subjects, subjectsDispatch } = useContext(SubjectContext);
  const [isLoading, setIsLoading] = useState(true);
  const { getToken } = useAuth();
  const axiosInstance = createAxiosInstance(getToken);

  //  pagination and filtering
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredSubjects, setFilteredSubjects] = useState([]);
  const itemsPerPage = 15;

  useEffect(() => {
    (async () => {
      try {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
      }
    })();
  }, []);

  // Filter subjects based on search term
  useEffect(() => {
    if (subjects?.data) {
      const filtered = subjects.data.filter((subject) =>
        subject.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredSubjects(filtered);
      setCurrentPage(1);
    }
  }, [searchTerm, subjects]);

  const handleRemove = async (id) => {
    const userConfirm = window.confirm("Are you sure?");
    if (userConfirm) {
      try {
        const response = await axiosInstance.delete(`api/subjects/${id}`);
        subjectsDispatch({ type: "REMOVE_SUBJECT", payload: id });
      } catch (err) {}
    }
  };

  // Pagination calculations
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredSubjects.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(filteredSubjects.length / itemsPerPage);

  if (isLoading) {
    return (
      <Container className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="d-flex justify-content-center align-items-center">
          <div className="spinner-border" role="status">
            <span className="sr-only"></span>
          </div>
          &nbsp;&nbsp;
          <p className="ml-3 mb-0 align-self-center">Loading... Please wait</p>
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <Breadcrumb>
        <Breadcrumb.Item href="/admin-dashboard">Home </Breadcrumb.Item>
        <Breadcrumb.Item active>Subjects List</Breadcrumb.Item>
      </Breadcrumb>
      <div className="container mt-4">
        <h2 className="mb-4">List Subjects:</h2>

        {/* Search input */}
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search subjects..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <thead className="thead-dark">
              <tr>
                <th>Sl. No.</th>
                <th>Name</th>
                <th>batch</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems.map((subject, i) => (
                  <tr key={subject._id || i}>
                    <td>{indexOfFirstItem + i + 1}</td>
                    <td>{subject.name}</td>
                    <td>
                      {subject.batch.map((batchId, i) => (
                        <span key={batchId}>
                          {props.batches1[batchId]}
                          {i < subject.batch.length - 1 ? ", " : ""}
                        </span>
                      ))}
                    </td>
                    <td>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleRemove(subject._id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3">No subjects found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination controls */}
        {totalPages > 1 && (
          <nav aria-label="Subject pagination" className="mt-3">
            <ul className="pagination justify-content-center">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => setCurrentPage(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
              </li>
              {[...Array(totalPages)].map((_, i) => (
                <li
                  key={i + 1}
                  className={`page-item ${
                    currentPage === i + 1 ? "active" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(i + 1)}
                  >
                    {i + 1}
                  </button>
                </li>
              ))}
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => setCurrentPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        )}
      </div>
    </Container>
  );
}
